import React, { useEffect, useRef, useState } from 'react';

type Props = {
	className: string;
	onFocus?: () => void;
	onBlur?: () => void;
	onKeyDown?: () => void;
	children: React.ReactNode | React.ReactNode[];
};

const TableInputContainer = ({ className, onFocus, onBlur, onKeyDown, children }: Props) => {
	const containerRef = useRef<HTMLDivElement>(null);
	const [isFocused, setIsFocused] = useState(true);

	useEffect(() => {
		const handleClickOutside = (e: MouseEvent) => {
			if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
				setIsFocused(false);
				onBlur?.();
			}
		};

		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.key === 'Enter' && onKeyDown) {
				onKeyDown();
			}
		};

		if (isFocused) {
			document.addEventListener('mousedown', handleClickOutside);
			document.addEventListener('keydown', handleKeyDown);
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [isFocused, onBlur, onKeyDown]);

	const handleContainerClick = () => {
		setIsFocused(true);
		onFocus?.();
	};

	return (
		<div ref={containerRef} className={className} onClick={handleContainerClick} tabIndex={-1}>
			{children}
		</div>
	);
};

export default TableInputContainer;
